export const MANUAL_CAPTURE_DURATION_MS = 3000;

export const getManualCaptureCountdown = (remainingMs) =>
  Math.max(0, Math.ceil(Math.max(Number(remainingMs) || 0, 0) / 1000));
